class ProdutoDuplicadoModal {
    static get $inject() {
        return ['$scope', 'Empresas', 'gql', '$filter']
    }

    constructor($scope, Empresas, gql, $filter) {
        this.apply = fn => $scope.$apply(fn)
        this.Empresas = Empresas
        this.gql = gql
        this.$filter = $filter

        $scope.$watch(() => this.empresaSelecionada, () => {
            if (this.produtosDuplicados && this.empresaSelecionada) {
                this.promise = this.listProdutosDuplicados(this.empresaSelecionada.cnpj)
            }
        })

        $scope.$watch(() => this.filiais, newValue => {
            if (newValue && !this.empresaSelecionada) {
                const filialIdOnCache = localStorage.getItem(`ef-filiais-selector-${this.resolve.empresaId}`)

                this.empresaSelecionada = newValue.find(filial => filial.id == filialIdOnCache)

                if (newValue.length == 1) {
                    this.empresaSelecionada = newValue[0]
                }

                this.empresaSelecionada = this.empresaSelecionada != null ? this.empresaSelecionada : null
            }
        })
    }

    $onInit() {
        this.loadingPromise = this.loadProdutosDuplicados(this.resolve.empresaId)
            .then(duplicados => {
                let produtosDuplicados = duplicados.map((duplicado) => {
                    return {
                        codigo: duplicado.codigo,
                        codigoBarras: duplicado.codigoBarras,
                        descricao: duplicado.descricao,
                        filial: {
                            cnpj: duplicado.filial.cnpj,
                            cidade: duplicado.filial.cidade.nome,
                            estado: duplicado.filial.cidade.estado.sigla
                        }
                    }
                })

                this.duplicadosBycodigoBarras = produtosDuplicados.groupBy((produto) => produto.codigoBarras)
                this.produtosDuplicados = { produtosDuplicados, total: Object.keys(this.duplicadosBycodigoBarras).length }

                this.duplicadosByFilial = this.produtosDuplicados.produtosDuplicados
                    .groupBy((produto) => produto.filial.cnpj)
                    .map((produtos) => {
                        return Object.keys(produtos.groupBy((produto) => produto.codigoBarras))
                    })
            })
            .finally(() => this.apply())

        this.promise = this.Empresas
            .listFiliais(this.resolve.empresaId)
            .then(filiais => this.filiais = filiais)
            .finally(() => this.apply())
    }

    loadProdutosDuplicados(empresaId) {
        const query = gql`
            query ProdutosCodigosDivergentes($empresaId: Int!) {
                empresa(id: $empresaId) {
                    id
                    produtosCodigosDivergentes {
                        id
                        codigo
                        codigoBarras
                        descricao
                        filial {
                            id
                            cnpj
                            cidade{
                                nome
                                estado {
                                    sigla
                                }
                            }
                        }
                    }
                }
            }
        `

        const variables = { empresaId: parseInt(empresaId) }

        return this.gql.query(query, variables)
            .then(({ empresa: { produtosCodigosDivergentes } }) => {

                return produtosCodigosDivergentes
            })
    }

    listProdutosDuplicados(filial) {
        if (filial) {
            this.duplicados = this.duplicadosByFilial[filial]
        }
        return []
    }

    highlight(search, empresa) {
        let duplicados = this.duplicadosByFilial[empresa.cnpj]
            ? ` - <b>Duplicados: ${this.duplicadosByFilial[empresa.cnpj].length}</b>`
            : ` - Duplicados: 0`

        const cnpj = this.$filter('cpfCnpj')(empresa.cnpj)
        const text = `${cnpj} (${empresa.cidade}/${empresa.estado})` + duplicados

        return search.split(' ').reduce(this.$filter('highlight'), text)
    }
}

angular.module("eficienciaFiscalModule")
    .component("produtoDuplicadoModal", {
        controller: ProdutoDuplicadoModal,
        bindings: {
            close: '&',
            resolve: '<'
        },
        template: `
            <modal modal-title="Produto duplicado entre as filiais do mesmo estado" close="$ctrl.close">
                <modal-body>
                    <loading promise="$ctrl.loadingPromise">
                        <div>
                            <h4>Você possui <b>{{$ctrl.produtosDuplicados.total.toString().padLeft(2, '0')}}</b> código(s) de barras em que o código do produto está diferente.</h4>
                        </div>
                        <br>
                        <div>
                            <label>Filial</label>
                            <ui-select 
                                theme="bootstrap"
                                name="empresa"
                                ng-model="$ctrl.empresaSelecionada"
                                ng-disabled="$ctrl.filiais.length == 1" 
                                style="width:100%;"
                                required="true">
                                <ui-select-match placeholder="Selecionar uma filial">
                                    {{$select.selected.cnpj | cpfCnpj}} ({{$select.selected.cidade}}/{{$select.selected.estado}}) - <b>Duplicados: {{$ctrl.duplicadosByFilial[$select.selected.cnpj].length || 0}}</b>
                                </ui-select-match>
                                <ui-select-choices repeat="empresa in ($ctrl.filiais | filter: $select.search) track by empresa.id">
                                    <div ng-bind-html="$ctrl.highlight($select.search, empresa)"></div>
                                </ui-select-choices>
                            </ui-select>
                        </div>
                        <br>
                        <div ng-if="$ctrl.empresaSelecionada">
                            <div ng-show="$ctrl.duplicados.length > 0">
                                <table class="table table-hover no-margin">
                                    <thead>
                                        <tr>
                                            <th style="width: 15%;">Código de barras</th>
                                            <th style="width: 10%;">Código</th>
                                            <th style="width: 45%;">Descrição</th>
                                            <th style="width: 30%;">Filial</th>
                                        </tr>
                                    </thead>
                                    <tbody ng-repeat="produtoDuplicado in $ctrl.duplicados">
                                        <tr>
                                            <td
                                                rowspan="{{$ctrl.duplicadosBycodigoBarras[produtoDuplicado].length + 1}}"
                                                style="vertical-align: middle;">
                                                {{produtoDuplicado}}
                                            </td>
                                        </tr>
                                        <tr ng-repeat="produto in $ctrl.duplicadosBycodigoBarras[produtoDuplicado]">
                                            <td>{{produto.codigo}}</td>
                                            <td>{{produto.descricao}}</td>
                                            <td>
                                                <a href="javascript:void(0)" ng-click="$ctrl.empresaSelecionada = produto.filial"> 
                                                    {{produto.filial.cnpj | cpfCnpj}} ({{produto.filial.cidade}}/{{produto.filial.estado}})
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div ng-hide="$ctrl.duplicados.length > 0">
                                <highlighted>
                                    <main>
                                        Nenhum produto duplicado para esta filial
                                    </main>
                                </highlighted>
                            </div>
                        </div>
                        <div ng-if="!$ctrl.empresaSelecionada">
                            <highlighted>
                                <main>
                                Selecione uma filial acima
                                </main>
                            </highlighted>
                        </div>
                        <br>    
                        <div>
                            <span class="text-muted" style="margin-left: 10px;">
                                * Deve ser atribuido o mesmo código para um mesmo item (código de barras) em todas as filiais de um estado.
                            </span>
                            <br>
                            <span class="text-muted" style="margin-left: 10px;">
                                ** Fonte legal: 
                                    <a target='_blank' href="http://sped.rfb.gov.br/estatico/0D/434EFF065B893AB70D59AD102A946DC9237680/2019.05.21_GUIA%20PR%c3%81TICO%20DA%20EFD%20-%20Vers%c3%a3o%203.0.3%20-%20v3%20para%20publica%c3%a7%c3%a3o.pdf">
                                        Guia Prático EFD-ICMS/IPI – Versão 3.0.3, Atualização: 14 de outubro de 2019.
                                    </a>
                            </span>
                            <br>
                            <span class="text-muted" style="margin-left: 10px;">
                                *** Para remover a duplicidade deve-se alterar o código do produto em sua base de dados.
                            </span>
                        </div>
                    </loading>
                </modal-body>
                <modal-footer>
                    <button class="btn btn-default" type="button" ng-click="$ctrl.close()">Fechar</button>
                </modal-footer>
            </modal>
        `
    })
